import { Injectable, Inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Language } from '../../../shared/models/common/language.model';
import { BaseService } from '../../../shared/services/base.service';
@Injectable({
    providedIn: 'root'
})
export class LanguagesService extends BaseService<Language> {

    private serviceMessage: { severity: string, summary: string, detail?: string } | null = null;

    setServiceMessage(message: { severity: string, summary: string, detail?: string }) {
        this.serviceMessage = message;
    }

    showServiceMessage() {
        if (this.serviceMessage) {
            this.messageService.add(this.serviceMessage);
            this.serviceMessage = null; // limpiar despu�s de mostrar
            setTimeout(() => {
                this.messageService.clear();
            }, 6000)
        }
    }

    getAllLanguages(): Observable<Language[]> {
         return this.http.get<Language[]>(`/api/languages`);
    }

    getLanguage(id: number): Observable<Language> {
        return this.http.get<Language>(`/api/languages`, {
            params: { id: id}
        });
    }

    deleteLanguage(language: Language): Observable<void> {

        const result$ = new Subject<void>();

        this.http.delete<Language>(`/api/languages`, {

            params: { id: language.id } 

        }).subscribe({

            next: (data) => {
                this.setServiceMessage({ severity: 'success', summary: this.translateService.instant('languages.management.remove_success') });
                result$.next();  // Notificamos al componente que todo sali� bien
                result$.complete();
            },

            error: (error) => {
                this.setServiceMessage({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                result$.error(error);
            }

        });

        return result$.asObservable();

    }

    saveLanguage(language: Language): Observable<void> {
        
        const result$ = new Subject<void>();

        if (language.id) {

            this.http.put<Language>(`/api/languages`, language).subscribe({

                next: (data) => {
                    this.setServiceMessage({ severity: 'success', summary: this.translateService.instant('languages.management.modified_success') });
                    result$.next();  // Notificamos al componente que todo sali� bien
                    result$.complete();
                },

                error: (error) => {
                    this.setServiceMessage({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                    result$.error(error);
                }

            });

        } else {
            this.http.post<Language>(`/api/languages`, language).subscribe({

                next: (data) => {
                    this.messageService.add({ severity: 'success', summary: this.translateService.instant('languages.management.created_success') });
                    result$.next();  // Notificamos al componente que todo sali� bien
                    result$.complete();
                },

                error: (error) => {
                    this.messageService.add({ severity: 'error', summary: this.translateService.instant('general.error'), detail: error.error.message })
                    result$.error(error);
                }

            });
        }

        return result$.asObservable();

    }

}
